import React from "react";
import { cn } from "../../lib/utils";

interface DetailSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
}

export const DetailSection: React.FC<DetailSectionProps> = ({
  icon,
  title,
  subtitle,
  toolbar,
  children,
  className,
  ...rest
}) => {
  return (
    <section
    className={cn(
      "rounded-2xl border border-border/70 bg-card/90 shadow-sm backdrop-blur-sm",
      className
    )}
      {...rest}
    >
      <div className="flex flex-col gap-3 border-b border-border/70 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          {icon && <div className="mt-1 text-xl text-primary/80">{icon}</div>}
          <div>
            <h3 className="text-lg font-semibold leading-tight text-foreground">
              {title}
            </h3>
            {subtitle && (
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            )}
          </div>
        </div>
        {toolbar && (
          <div className="flex flex-wrap gap-2 sm:justify-end">{toolbar}</div>
        )}
      </div>
      <div className="px-6 py-6">
        <div className="space-y-4 text-sm text-foreground/80">{children}</div>
      </div>
    </section>
  );
};

export default DetailSection;
